<div
    #loginInfo
    id="userLoginInfo"
    class="flex align-items-center"
    [style.cursor]="'pointer'"
    (click)="menu.toggle($event)">
    <img class="profile-image border-circle" [src]="app.avatarUrl" />
    <div id="userOrganization" class="flex flex-column">
        <div>
            <b>{{ currentOrganization?.name }}</b>
        </div>
        <div>{{ app.currentUserName }}</div>
    </div>
</div>

<p-menu #menu [popup]="true" [appendTo]="appendTo" [styleClass]="'custom-menu-wrapper'" [model]="menuItems"></p-menu>
